import React from 'react';
import { Link } from 'react-router-dom';
import TopNavBar from '../layout/TopNavBar';
import SideNavBar from '../layout/SideNavBar';

export default function ProjectsView() {
  const projects = [
    {
      id: 1,
      title: "Neon Nights - Synthwave",
      time: "Edited 2 hours ago",
      image: "https://lh3.googleusercontent.com/aida-public/AB6AXuBnUBCJwPH4MzmzcUZtdiuIXwT1N-540pIXmNIUY21yru1BbFSY0QKvTa1oy1caJ4wbUSV1g3-mTibjkvvQBG9s7b8hRYafYDz4mjUlfaTKvDFc8kynaqrLNWR72b62T7z3t_yzHkAMjHZcAoncECVgVAEDtQxP2d6QIH8U0ofZYQUhtRuwhPn-nxMVqvDFM9Y9hr-f5lxDuOWsRugl3juo-CBa1RWP7O1J8Y9PIqse0BuBlz5wVyjY4j-Q6SoxdQw87aul19BtFGCX",
      status: "Synced"
    },
    {
      id: 2,
      title: "Acoustic Session 04",
      time: "Edited yesterday",
      isDraft: true
    },
    {
      id: 3,
      title: "Live at The Roxy",
      time: "Edited 3 days ago",
      image: "https://lh3.googleusercontent.com/aida-public/AB6AXuDdnYX5qVY3SC6nj0qFclv-lZQTtAqI5oYzaPV-OAzJxRSSZWsO4XAxh0OdvJ3cqYB1pAP8Zn_ib_Z5bQODG0GId9fS1q4BAdXbKBnvXyfVc8mU9okJh3UPtK0WCiCwJln2vNdbDoB8Y_qobh4PZ67Wv0P61PHJ0VXdTTjeoSC51lNv907z1KngkrpSVCNa3DHIKZdFWuLse4bxvvsLmcYAv6ITZBfgLldkU58QCbDz4_c_2E8auFXx2fHoLwvIyFd97_ZRrPg_vPUd"
    }
  ];

  return (
    <div className="flex flex-col h-full w-full">
      <TopNavBar />
      <div className="flex-1 flex overflow-hidden">
        <SideNavBar />
        <main className="flex-1 overflow-y-auto p-section-margin bg-background">
          <div className="max-w-7xl mx-auto flex flex-col gap-section-margin">
            
            <div className="flex justify-between items-end">
              <div>
                <h1 className="font-headline-h1 text-headline-h1 text-on-surface mb-2">Projects</h1>
                <p className="font-body-md text-body-md text-on-surface-variant">Manage your recent lyric videos and asset libraries.</p>
              </div>
              <div className="flex gap-widget-padding-sm">
                <button className="px-4 py-2 border border-outline-variant rounded-lg text-on-surface font-label-md hover:bg-surface-container-low transition-colors flex items-center gap-2">
                  <span className="material-symbols-outlined text-[18px]">filter_list</span> Filter
                </button>
                <Link to="/editor" className="px-4 py-2 bg-primary text-on-primary rounded-lg font-label-md hover:opacity-90 transition-opacity flex items-center gap-2">
                  <span className="material-symbols-outlined text-[18px]">add</span> New Project
                </Link>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-gutter">
              {projects.map((project) => (
                <Link 
                  key={project.id} 
                  to="/editor"
                  className="group flex flex-col bg-surface-container-low rounded-xl border border-outline-variant/30 hover:border-outline-variant transition-all cursor-pointer overflow-hidden relative"
                >
                  <div className="aspect-video w-full bg-surface-container-highest relative overflow-hidden">
                    {project.image ? (
                      <img 
                        className={`w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 opacity-80 ${project.id === 3 ? 'grayscale mix-blend-luminosity' : ''}`}
                        src={project.image} 
                        alt={project.title}
                      />
                    ) : (
                      <div className="w-full h-full bg-gradient-to-br from-secondary-container to-surface-container flex items-center justify-center group-hover:scale-105 transition-transform duration-500">
                        <span className="material-symbols-outlined text-[48px] text-on-secondary-container opacity-50">music_note</span>
                      </div>
                    )}
                    
                    {project.status === "Synced" && (
                      <div className="absolute top-2 right-2 bg-surface/80 backdrop-blur-sm border border-outline-variant px-2 py-1 rounded font-label-sm text-label-sm text-on-surface flex items-center gap-1">
                        <span className="material-symbols-outlined text-[14px] text-primary">sync</span> Synced
                      </div>
                    )}
                    {project.isDraft && (
                      <div className="absolute top-2 right-2 bg-surface/80 backdrop-blur-sm border border-error/30 px-2 py-1 rounded font-label-sm text-label-sm text-error flex items-center gap-1">
                        <span className="material-symbols-outlined text-[14px]">error</span> Draft
                      </div>
                    )}
                  </div>
                  <div className="p-panel-padding flex flex-col gap-1">
                    <h3 className="font-headline-h3 text-headline-h3 text-on-surface truncate">{project.title}</h3>
                    <p className="font-label-sm text-label-sm text-on-surface-variant">{project.time}</p>
                  </div>
                </Link>
              ))}
            </div>

          </div>
        </main>
      </div>
    </div>
  );
}
